var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "level" },
          [
            _c(
              "Header",
              _vm._b(
                { staticClass: "level-left" },
                "Header",
                _vm.$route.meta,
                false
              )
            ),
            _c(
              "b-button",
              {
                staticClass: "left-right",
                attrs: {
                  type: "is-success",
                  "icon-left": "plus",
                  disabled: _vm.isLoading,
                },
                on: {
                  click: function ($event) {
                    return _vm.showCreateForm()
                  },
                },
              },
              [_vm._v(" Import New Shipments ")]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Start Date" } },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          name: "startdate",
                          "first-day-of-week": 1,
                          locale: "en-CA",
                          icon: "calendar-alt",
                          placeholder: "Start date",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.unverifyData()
                          },
                        },
                        model: {
                          value: _vm.start,
                          callback: function ($$v) {
                            _vm.start = $$v
                          },
                          expression: "start",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "End Date" } },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          name: "enddate",
                          "first-day-of-week": 1,
                          locale: "en-CA",
                          icon: "calendar-alt",
                          placeholder: "End date",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.unverifyData()
                          },
                        },
                        model: {
                          value: _vm.end,
                          callback: function ($$v) {
                            _vm.end = $$v
                          },
                          expression: "end",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "left-right",
                          attrs: {
                            type: "is-warning",
                            "icon-left": "arrows-rotate",
                            disabled: _vm.isLoading,
                          },
                          on: {
                            click: () => {
                              _vm.resetData()
                              _vm.getData()
                            },
                          },
                        },
                        [_vm._v(" Load ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "left-right",
                          attrs: {
                            type: "is-warning",
                            "icon-left": "save",
                            disabled:
                              _vm.shipments.length <= 0 ||
                              _vm.isLoading ||
                              !_vm.isLoaded,
                          },
                          on: {
                            click: () => {
                              _vm.showExportForm()
                            },
                          },
                        },
                        [_vm._v(" Export to Excel ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "left-right",
                          attrs: {
                            type: "is-success",
                            "icon-left": "plus",
                            disabled:
                              _vm.shipments.length <= 0 ||
                              _vm.isLoading ||
                              !_vm.isLoaded,
                          },
                          on: {
                            click: () => {
                              _vm.showDataForm()
                            },
                          },
                        },
                        [_vm._v(" Calculate Volume ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.shipments.length != 0
                ? _c("ag-grid-vue", {
                    staticClass: "ag-theme-balham",
                    staticStyle: { width: "100%", height: "700px" },
                    attrs: {
                      "row-data": _vm.shipments,
                      "grid-options": _vm.gridOptions,
                      pagination: true,
                      "pagination-auto-page-size": true,
                      "cache-overflow-size": 0,
                      "multi-sort-key": "ctrl",
                      modules: _vm.modules,
                      "get-context-menu-items": _vm.getContextMenuItems,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isCreatingShipments,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCreatingShipments = $event
            },
          },
        },
        [
          _vm.isCreatingShipments
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitShipments.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Load Shipments "),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                [
                                  _c("input", {
                                    attrs: {
                                      id: "fileUpload",
                                      type: "file",
                                      accept: ".csv",
                                      hidden: "",
                                    },
                                    on: { change: _vm.loadTextFromFile },
                                  }),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn",
                                      on: { click: _vm.chooseFiles },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "pages.customer_forecast.upload_csv"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                {
                                  attrs: {
                                    label: "Date Format",
                                    "label-position": "inside",
                                  },
                                },
                                [
                                  _c(
                                    "b-select",
                                    {
                                      model: {
                                        value: _vm.format,
                                        callback: function ($$v) {
                                          _vm.format = $$v
                                        },
                                        expression: "format",
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { value: "dd/mm/yyyy" } },
                                        [_vm._v(" dd/mm/yyyy ")]
                                      ),
                                      _c(
                                        "option",
                                        { attrs: { value: "mm/dd/yyyy" } },
                                        [_vm._v(" mm/dd/yyyy ")]
                                      ),
                                      _c(
                                        "option",
                                        { attrs: { value: "yyyy/mm/dd" } },
                                        [_vm._v(" yyyy/mm/dd ")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._l(
                            _vm.newShipmentErrors,
                            function (error, index) {
                              return _c(
                                "b-field",
                                {
                                  key: "error" + index,
                                  style: {
                                    "border-left": "6px solid rgb(255, 0, 0)",
                                    "padding-left": "1rem",
                                    "margin-bottom": "0.1rem",
                                    backgroundColor: "rgb(245, 250, 248)",
                                  },
                                },
                                [_vm._v(" " + _vm._s(error) + " ")]
                              )
                            }
                          ),
                          _c(
                            "table",
                            {
                              style: {
                                backgroundColor: "white",
                                border: "2px, solid, rgb(140 140 140)",
                                marginTop: "0.9rem",
                              },
                            },
                            [
                              _c(
                                "tr",
                                {
                                  style: {
                                    backgroundColor: "rgb(190, 190, 250)",
                                  },
                                },
                                [
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Ship To ")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Timestamp ")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Quantity ")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Ship From ")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Extra ")]
                                  ),
                                ]
                              ),
                              _vm._l(
                                _vm.newShipments,
                                function (shipment, index) {
                                  return _c("tr", { key: "row" + index }, [
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.ship_to) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.timestamp) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.quantity) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.ship_from) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.misc) + " "
                                        ),
                                      ]
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        2
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: {
                              type: "submit",
                              disabled:
                                _vm.newShipmentErrors &&
                                _vm.newShipmentErrors.length > 0,
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditingShipment,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditingShipment = $event
            },
          },
        },
        [
          _vm.isEditingShipment
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitEdit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Edit Shipment "),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Date" } },
                                [
                                  _c("b-datepicker", {
                                    attrs: {
                                      name: "editdate",
                                      "first-day-of-week": 1,
                                      locale: "en-CA",
                                      icon: "calendar-alt",
                                    },
                                    model: {
                                      value: _vm.editableShipment.timestamp,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editableShipment,
                                          "timestamp",
                                          $$v
                                        )
                                      },
                                      expression: "editableShipment.timestamp",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Ship To" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.editableShipment.ship_to,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editableShipment,
                                      "ship_to",
                                      $$v
                                    )
                                  },
                                  expression: "editableShipment.ship_to",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Quantity" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.editableShipment.quantity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editableShipment,
                                      "quantity",
                                      $$v
                                    )
                                  },
                                  expression: "editableShipment.quantity",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Ship From" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.editableShipment.ship_from,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editableShipment,
                                      "ship_from",
                                      $$v
                                    )
                                  },
                                  expression: "editableShipment.ship_from",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Misc" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.editableShipment.misc,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editableShipment, "misc", $$v)
                                  },
                                  expression: "editableShipment.misc",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isExporting,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isExporting = $event
            },
          },
        },
        [
          _vm.isExporting
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.exportToExcel.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Export Data "),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Ship From" } },
                                [
                                  _c("multiselect", {
                                    staticStyle: { "min-width": "400px" },
                                    attrs: {
                                      options: _vm.exportShipFromOptions,
                                      multiple: false,
                                      "close-on-select": true,
                                      placeholder: "Pick ship from",
                                    },
                                    model: {
                                      value: _vm.exportShipFrom,
                                      callback: function ($$v) {
                                        _vm.exportShipFrom = $$v
                                      },
                                      expression: "exportShipFrom",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                { attrs: { label: "Ship To" } },
                                [
                                  _c("multiselect", {
                                    staticStyle: { "min-width": "400px" },
                                    attrs: {
                                      options: _vm.exportShipToOptions,
                                      multiple: false,
                                      "close-on-select": true,
                                      placeholder: "Pick ship to",
                                    },
                                    model: {
                                      value: _vm.exportShipTo,
                                      callback: function ($$v) {
                                        _vm.exportShipTo = $$v
                                      },
                                      expression: "exportShipTo",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "left-right",
                                      attrs: {
                                        type: "is-warning",
                                        "icon-left": "arrows-rotate",
                                        disabled: _vm.isLoading,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.prepExport()
                                        },
                                      },
                                    },
                                    [_vm._v(" Load ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "table",
                            {
                              style: {
                                backgroundColor: "white",
                                border: "2px, solid, rgb(140 140 140)",
                                marginTop: "0.9rem",
                              },
                            },
                            [
                              _c(
                                "tr",
                                {
                                  style: {
                                    backgroundColor: "rgb(190, 190, 250)",
                                  },
                                },
                                [
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Ship To ")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Timestamp ")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Quantity ")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Ship From ")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Extra ")]
                                  ),
                                ]
                              ),
                              _vm._l(
                                _vm.exportShipments,
                                function (shipment, index) {
                                  return _c("tr", { key: "row" + index }, [
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.ship_to) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.timestamp) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.quantity) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.ship_from) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.misc) + " "
                                        ),
                                      ]
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: {
                              type: "submit",
                              disabled: _vm.exportShipments.length <= 0,
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isCalculating,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCalculating = $event
            },
          },
        },
        [
          _vm.isCalculating
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Data "),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Ship From" } },
                                [
                                  _c("multiselect", {
                                    staticStyle: { "min-width": "400px" },
                                    attrs: {
                                      options: _vm.dataShipFromOptions,
                                      multiple: false,
                                      "close-on-select": true,
                                      placeholder: "Pick ship from",
                                    },
                                    model: {
                                      value: _vm.dataShipFrom,
                                      callback: function ($$v) {
                                        _vm.dataShipFrom = $$v
                                      },
                                      expression: "dataShipFrom",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                { attrs: { label: "Ship To" } },
                                [
                                  _c("multiselect", {
                                    staticStyle: { "min-width": "400px" },
                                    attrs: {
                                      options: _vm.dataShipToOptions,
                                      multiple: false,
                                      "close-on-select": true,
                                      placeholder: "Pick ship to",
                                    },
                                    model: {
                                      value: _vm.dataShipTo,
                                      callback: function ($$v) {
                                        _vm.dataShipTo = $$v
                                      },
                                      expression: "dataShipTo",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "left-right",
                                      attrs: {
                                        type: "is-warning",
                                        "icon-left": "arrows-rotate",
                                        disabled: _vm.isLoading,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.prepData()
                                        },
                                      },
                                    },
                                    [_vm._v(" Load ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("b-field", [
                            _vm._v(
                              " Total Volume: " +
                                _vm._s(
                                  _vm.dataShipments.reduce(
                                    (sum, element) => sum + element.quantity,
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("b-field", [
                            _vm._v(
                              " Average Daily Volume: " +
                                _vm._s(_vm.dataMean?.toFixed(3)) +
                                " "
                            ),
                          ]),
                          _c("b-field", [
                            _vm._v(
                              " Average Day's Volume: " +
                                _vm._s(_vm.dataDailyMean?.toFixed(3)) +
                                " "
                            ),
                          ]),
                          _c(
                            "table",
                            {
                              style: {
                                backgroundColor: "white",
                                border: "2px, solid, rgb(140 140 140)",
                                marginTop: "0.9rem",
                              },
                            },
                            [
                              _c(
                                "tr",
                                {
                                  style: {
                                    backgroundColor: "rgb(190, 190, 250)",
                                  },
                                },
                                [
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Ship To ")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Timestamp ")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Quantity ")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Ship From ")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      style: {
                                        border: "1px solid rgb(160 160 160)",
                                        padding: "8px 10px",
                                      },
                                      attrs: { scope: "col" },
                                    },
                                    [_vm._v(" Extra ")]
                                  ),
                                ]
                              ),
                              _vm._l(
                                _vm.dataShipments,
                                function (shipment, index) {
                                  return _c("tr", { key: "datarow" + index }, [
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.ship_to) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.timestamp) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.quantity) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.ship_from) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        style: {
                                          border: "1px solid rgb(160 160 160)",
                                          padding: "8px 10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(shipment.misc) + " "
                                        ),
                                      ]
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }